import { CSSProperties } from "react";
export const callScreenWrapperStyle = () => {
  return {
    width: "100%",
    height: "100%",
    inset: "0",
  } as CSSProperties;
};
